export default __webpack_public_path__ + "static/media/logo-webdev.b7868418.svg";